import { createContext } from 'react';

import { State, createState } from '@hookstate/core';

import { IUpdateRawQueryList } from '@models/Update.model';
import { UpdatesLoading } from './Updates.loading';
import { UpdatesError } from './Updates.error';
import { UpdatesAssignedToMeRaw } from './UpdatesAssignedToMe.raw';

export type SortUpdatesAssignedToMeTypes =
  | 'assignee'
  | 'priority'
  | 'subject'
  | 'dueDate'
  | 'affects'
  | 'date'
  | 'count'
  | 'pManufacturers'
  | undefined;

export type DirectionUpdatesAssignedToMetypes = 'ASC' | 'DESC' | undefined;

interface IUpdatesAssignedToMeContext {
  search: State<string>;
  sort: State<SortUpdatesAssignedToMeTypes>;
  direction: State<DirectionUpdatesAssignedToMetypes>;
}

export const UpdatesAssignedToMeContext =
  createContext<IUpdatesAssignedToMeContext>({
    search: createState<string>(''),
    sort: createState<SortUpdatesAssignedToMeTypes>(undefined),
    direction: createState<DirectionUpdatesAssignedToMetypes>(undefined),
  });

interface IUpdatesAssignedToMeQuery {
  data: IUpdateRawQueryList[];
  isLoading: boolean;
  isError: boolean;
  hasMore?: boolean;
  loadMore: () => void;
}

const UpdatesAssignedToMeQuery = ({
  data,
  isLoading,
  isError,
  loadMore,
  hasMore,
}: IUpdatesAssignedToMeQuery) => {
  if (isLoading || !data) {
    return <UpdatesLoading />;
  }

  if (isError) {
    return <UpdatesError />;
  }

  return (
    <UpdatesAssignedToMeRaw
      updateStatuses={data}
      loadMore={loadMore}
      hasMore={hasMore}
    />
  );
};

export { UpdatesAssignedToMeQuery };
